module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image16a.37a9e3cb.webp";